import {
  AddIcon,
  ArrowDownIcon,
  ArrowUpDownIcon,
  ArrowUpIcon,
  WarningTwoIcon,
} from '@chakra-ui/icons';
import {
  Card,
  CardBody,
  CardFooter,
  Grid,
  GridItem,
  Heading,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Table,
  TableContainer,
  Tag,
  TagLabel,
  TagLeftIcon,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useDoorData } from './context/DoorContext';
import CreateEmployeeModal from './CreateEmployeeModal';

const DEBUG = false; // įjunk į true, jei reikia debug

function AccessLogCardIps() {
  const {
    log,
    logAllIps,
    loadLogAllIps,
    getDoorStatusBadge,
    getDoorName,
    userLogIps,
    pickedUserLog,
    loading,
    loadDataFromEmaitinimas,
    systemDoors,
    user,
  } = useDoorData();

  // kuriuos logus rodom – iš visų IP, jei yra, kitaip seną log
  const activeLog = (logAllIps && logAllIps.length ? logAllIps : log) || [];

  if (DEBUG) {
    console.log('🚀 [AccessLogCardIps] MOUNT, activeLog length =', activeLog.length);
  }

  const [clickedLogBox, setClickedLogBox] = useState(null);
  const [clickedLogCardNo, setClickedLogCardNo] = useState(null);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenUserLog,
    onOpen: onOpenUserLog,
    onClose: onCloseUserLog,
  } = useDisclosure();

  // DoorID -> { name, ip }
  const [doorInfoById, setDoorInfoById] = useState({});

  useEffect(() => {
    if (!systemDoors || systemDoors.length === 0) return;

    const map = {};
    for (const d of systemDoors) {
      const serial = d?.DoorSerial ? String(d.DoorSerial).trim() : '';
      map[d.DoorID] = {
        name: d.DoorName,
        ip: serial !== '' ? serial : null,
      };
    }
    setDoorInfoById(map);

    if (DEBUG) {
      console.log('🔎 [AccessLogCardIps] systemDoors:', systemDoors);
      console.log('🔎 [AccessLogCardIps] doorInfoById:', map);
    }
  }, [systemDoors]);

  // IP ir durų pavadinimas pagal globalų DoorID iš getAllSystemDoors
  const getDoorInfoForRow = (row) => {
    if (!row) return { name: '', ip: null };

    const doorId = row.door_id ?? row.doorID ?? row.DoorID ?? 0;
    if (doorId === 0) return { name: 'Visos durys', ip: null };

    const info = doorInfoById[doorId];
    if (info) return info;

    return { name: getDoorName ? getDoorName(doorId) : String(doorId), ip: null };
  };

  // auto atsinaujinantys logai kaip "status fetch"
  useEffect(() => {
    if (!user) return; // neprisijungus – nerefreshinam

    const fetchLogs = () => {
      loadLogAllIps(30);
    };

    // pirmas užkrovimas iškart
    fetchLogs();

    // kas 5 sekundes atsinaujina
    const id = setInterval(fetchLogs, 5000);

    // išvalom intervalą, kai komponentas unmountinamas arba user pasikeičia
    return () => clearInterval(id);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (!DEBUG) return;
    console.log('🧱 [AccessLogCardIps] log entries:', log);
  }, [log]);

  useEffect(() => {
    if (!DEBUG) return;
    console.log('🧱 [AccessLogCardIps] pickedUserLog entries:', pickedUserLog);
  }, [pickedUserLog]);

  return (
    <>
      <Grid
        mx={'5vw'}
        gridRow={'5'}
        templateColumns={'repeat(auto-fill, minmax(160px,1fr))'}
        gap={6}
        autoColumns={'minmax(160px,1fr)'}
        sx={{
          '::-webkit-scrollbar': {
            width: '16px',
          },
          '::-webkit-scrollbar-track': {
            backgroundColor: '#e4e4e4',
            borderRadius: '2rem',
          },
          '::-webkit-scrollbar-thumb': {
            backgroundColor: '#cecece',
            borderRadius: '2rem',
          },
        }}
        overflowX={'scroll'}
        gridAutoFlow={'column'}
      >
        {activeLog.map((logEntry, index) => {
          // ne-mutuoju originalo, susikuriu vietinius kintamuosius
          const name = loadDataFromEmaitinimas ? logEntry.name : logEntry.pname;
          const surname = loadDataFromEmaitinimas ? logEntry.surname : logEntry.psurname;

          const date = new Date(logEntry.date).toLocaleString('lt-LT');
          const { name: doorNameFromMap, ip: ipFromMap } = getDoorInfoForRow(logEntry);

          const doorName =
            logEntry.door_id === 0 ? 'Visos durys' : doorNameFromMap || getDoorName(logEntry.door_id);

          const fullName = `${name} ${surname}`;
          const logAction = getDoorStatusBadge(logEntry.action);

          if (DEBUG) {
            console.log('🔍 [AccessLogCardIps] kortelė:', {
              id: logEntry.id,
              door_id: logEntry.door_id,
              doorName,
              mapIp: ipFromMap,
            });
          }

          return (
            <GridItem cursor={'pointer'}  key={logEntry.id ?? logEntry.card_no}  >
              
              <Card
                minHeight={'10rem'}
                mb={'0.5rem'}
                border={`solid 1px ${logAction.bgColor}`}
              >
                {!loadDataFromEmaitinimas &&
                  logEntry.action === 'NOT_FOUND' &&
                  logEntry.pname === null && (
                    <IconButton
                      size={'xs'}
                      colorScheme={'green'}
                      borderRadius={'0 0 1rem 0'}
                      position={'absolute'}
                      icon={<AddIcon />}
                      onClick={() => {
                        setClickedLogCardNo(logEntry.card_no);
                        onOpen();
                      }}
                    />
                  )}

                <CardBody
                  onClick={() => {
                    if (!user) return;
                    console.log(
                      '🟦 [AccessLogCardIps] kortelė click, card_no=',
                      logEntry.card_no
                    );
                    userLogIps(logEntry.card_no);
                    setClickedLogBox(logEntry.id);
                    onOpenUserLog();
                  }}
                >
                  <Tag size={'sm'} variant="outline" colorScheme={logAction.color}>
                    <TagLeftIcon as={logAction.icon} />
                    <TagLabel>{logAction.text}</TagLabel>
                  </Tag>

                  {logEntry.drunk > '0.000' && (
                    <Text
                      fontSize={'md'}
                      mb={'5px'}
                      color={'red'}
                      minHeight={'1rem'}
                    >
                      <WarningTwoIcon /> {logEntry.drunk}{' '}
                      <WarningTwoIcon />
                    </Text>
                  )}

                  <Text
                    fontSize={'xs'}
                    mb={'5px'}
                    color={'#a7a7a7'}
                    minHeight={'1rem'}
                  >
                    {logEntry.groupname}
                  </Text>

                  <Heading minHeight={'3rem'} size="sm">
                    {logEntry.direction !== '' ? (
                      logEntry.direction === 'INSIDE' ? (
                        <Tooltip hasArrow label="Vidinės durys" fontSize="md">
                          <ArrowUpIcon ml={'-1rem'} color={logAction.color} />
                        </Tooltip>
                      ) : (
                        <Tooltip hasArrow label="Išorinės durys" fontSize="md">
                          <ArrowDownIcon ml={'-1rem'} color={logAction.color} />
                        </Tooltip>
                      )
                    ) : (
                      <ArrowUpDownIcon ml={'-1rem'} color={logAction.color} />
                    )}{' '}
                    {name == null ? logEntry.card_no : fullName}
                  </Heading>

                  <Text fontSize={'sm'} mt={'1rem'}>
                    {logEntry.door_id === 0
                      ? 'Visos durys'
                      : `${doorName}${ipFromMap ? ` (IP: ${ipFromMap})` : ''}`}
                  </Text>
                </CardBody>

                <CardFooter p={'0'} pb={'0.3rem'} justifyContent={'center'}>
                  <Text fontSize={'sm'} color={'gray'}>
                    {date}
                  </Text>
                </CardFooter>
              </Card>
            </GridItem>
          );
        })}
      </Grid>

      <CreateEmployeeModal
        onlyCreate={true}
        onOpen={onOpen}
        isOpen={isOpen}
        onClose={onClose}
        editMode={false}
        editEmployee={{
          name: '',
          surname: '',
          cardno: clickedLogCardNo,
          group: null,
        }}
        setEditEmployee={[]}
      />

      <Modal isOpen={isOpenUserLog} size={'6xl'} onClose={onCloseUserLog}>
        <ModalOverlay />
        <ModalContent>
          {loadDataFromEmaitinimas ? (
            <ModalHeader>
              {pickedUserLog[0]?.name !== null &&
                `${pickedUserLog[0]?.name} ${pickedUserLog[0]?.surname} naujausi praėjimo įrašai`}
            </ModalHeader>
          ) : (
            <ModalHeader>
              {pickedUserLog[0]?.pname !== null &&
                `${pickedUserLog[0]?.pname} ${pickedUserLog[0]?.psurname} naujausi praėjimo įrašai`}
            </ModalHeader>
          )}

          <ModalCloseButton />
          <ModalBody>
            {loading ? (
              <Spinner
                thickness="4px"
                speed="0.65s"
                emptyColor="gray.200"
                color="green.500"
                size="xl"
              />
            ) : (
              <TableContainer>
                <Table
                  maxHeight={'60vh'}
                  display={'block'}
                  overflowY={'scroll'}
                  variant="simple"
                >
                  <Thead>
                    <Tr>
                      <Th>ID</Th>
                      <Th>Vardas Pavardė</Th>
                      <Th>Kortelės Nr.</Th>
                      {!loadDataFromEmaitinimas && <Th>Kortelės gr.</Th>}
                      <Th>Duru ID</Th>
                      <Th>IP</Th>
                      <Th>Kryptis</Th>
                      <Th>Data ir laikas</Th>
                      <Th textAlign={'center'}>Veiksmas</Th>
                    </Tr>
                  </Thead>

                  <Tbody>
                    {pickedUserLog.map((logRow, index) => {
                      const logRowAction = getDoorStatusBadge(logRow.action);

                      const rowName = loadDataFromEmaitinimas
                        ? logRow.name
                        : logRow.pname;
                      const rowSurname = loadDataFromEmaitinimas
                        ? logRow.surname
                        : logRow.psurname;

                      const { name: doorNameFromMap, ip: ipFromMap } =
                        getDoorInfoForRow(logRow);

                      const doorName =
                        logRow.door_id === 0
                          ? 'Visos durys'
                          : doorNameFromMap || getDoorName(logRow.door_id);

                      if (DEBUG) {
                        console.log('🔍 [AccessLogCardIps] modal row:', {
                          id: logRow.id,
                          door_id: logRow.door_id,
                          doorName,
                          mapIp: ipFromMap,
                        });
                      }

                      return (
                        <Tr
                          key={index}
                          backgroundColor={
                            clickedLogBox === logRow.id ? 'green.400' : ''
                          }
                          color={clickedLogBox === logRow.id ? 'white' : ''}
                        >
                          <Td>{logRow.id}</Td>
                          <Td>
                            {rowName !== null &&
                              `${rowName} ${rowSurname}`}
                          </Td>
                          <Td>{logRow.card_no}</Td>
                          {!loadDataFromEmaitinimas && (
                            <Td>{logRow.groupname}</Td>
                          )}
                          <Td>
                            {logRow.door_id === 0 ? 'Visos' : logRow.door_id}
                          </Td>
                          <Td>{ipFromMap || '-'}</Td>
                          <Td>
                            {logRow.direction === 'OUTSIDE'
                              ? 'Išorinės'
                              : logRow.direction === 'INSIDE'
                              ? 'Vidinės'
                              : logRow.direction}
                          </Td>
                          <Td>
                            {new Date(logRow.date).toLocaleString('lt-LT')}
                          </Td>
                          <Td>
                            <Tag
                              size={'sm'}
                              variant="solid"
                              colorScheme={
                                clickedLogBox === logRow.id
                                  ? ''
                                  : logRowAction.color
                              }
                            >
                              <TagLeftIcon as={logRowAction.icon} />
                              <TagLabel>{logRowAction.text}</TagLabel>
                            </Tag>
                          </Td>
                        </Tr>
                      );
                    })}
                  </Tbody>
                </Table>
              </TableContainer>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default AccessLogCardIps;
